import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
})
export class BadgeComponent {
  label = input.required<string>();
  tailwindColor = input<string>('neutral');

  /**
   * Tailwind generates only static classes at build time.
   * Dynamic strings like `text-${color}-800` won't be included.
   * Using a static mapping ensures all needed classes exist.
   */
  protected readonly colorMap: Record<string, string> = {
    neutral: 'text-neutral-800 bg-neutral-100',
    green: 'text-green-800 bg-green-100',
    yellow: 'text-yellow-800 bg-yellow-100',
    red: 'text-red-800 bg-red-100',
    blue: 'text-blue-800 bg-blue-100',
    purple: 'text-purple-800 bg-purple-100',
    pink: 'text-pink-800 bg-pink-100',
    indigo: 'text-indigo-800 bg-indigo-100',
  };

  protected readonly colorClasses = computed(() => {
    return this.colorMap[this.tailwindColor()] || this.colorMap.neutral;
  });
}
